export abstract class FormValidators {
    public static REQUIRED(msg: string = ''): (value: any) => any {
        return (value: any) => FormValidators.response(!!value, msg);
    }

    public static EMAIL(msg: string = ''): (value: any) => any {
        return (value: any) => FormValidators.response(/\S+@\S+\.\S+/.test(value), msg);
    }

    private static response(isValid: boolean, message: string) {
        return {isValid, message};
    }
}
